// @ts-check
import A11yDialog from 'Carbon.Dialog/Resources/Private/Assets/_A11yDialog';
import PerfectScrollbar from 'perfect-scrollbar';
import Gator from 'gator';

let dialogues = {};
const CLASS_LIST = document.documentElement.classList;
const ACTIVE_CLASS = '-carbon-dialog-active';

if (window.name == 'dialog__iframe') {
    const ELEMENT = document.querySelector('.site');
    if (ELEMENT && ELEMENT instanceof HTMLElement) {
        ELEMENT.style.overflow = 'hidden';
        ELEMENT.style.position = 'absolute';
        ELEMENT.style.top = '0';
        ELEMENT.style.bottom = '0';
        new PerfectScrollbar(ELEMENT, {
            suppressScrollX: true,
        });
    }
}

Carbon('domReady')(() => {
    let ids = [];
    Carbon('nodeArray')('.carbon-dialog').forEach((element) => {
        let id = element.id;
        if (ids.includes(id)) {
            console.warn(`The dialog id ${id} is already taken! Please change to key of the dialog.`);
        } else {
            ids.push(id);
            let scrollbar = null;

            /** @type {HTMLElement | null} */
            const CONTENT = element.querySelector('.carbon-dialog__content');
            const HAS_SCROLLBAR = typeof element.dataset.scrollbar != 'undefined';
            dialogues[id] = new A11yDialog(element);
            dialogues[id].on('show', () => {
                CLASS_LIST.add(ACTIVE_CLASS);

                if (HAS_SCROLLBAR && CONTENT) {
                    scrollbar = new PerfectScrollbar(CONTENT, {
                        suppressScrollX: true,
                    });
                }
            });
            dialogues[id].on('hide', () => {
                CLASS_LIST.remove(ACTIVE_CLASS);
                if (scrollbar) {
                    scrollbar.destroy();
                    scrollbar = null;
                }
            });
        }
    });

    // Open dialog on startup with #dialog__KEYNAME
    let hash = location.hash.substr(1);
    if (hash && dialogues[`carbon-${hash}`]) {
        // Remove hash
        history.pushState('', document.title, `${location.pathname}${location.search}`);
        // Show dialog
        dialogues[`carbon-${hash}`].show();
    }
});

Carbon('dialogues', dialogues);

Gator(document).on('click', 'a[data-a11y-dialog-show]', (event) => {
    event.preventDefault();
});

const loginDefault = 'carbon-dialog__login-default';
Gator(document).on('click', 'a[href="#login"]', (event) => {
    if (dialogues[loginDefault]) {
        event.preventDefault();
        dialogues[loginDefault].show();
    }
});
